// import axios from "axios";
// import qs from "qs";
// import { useEffect, useState } from "react";
// import { generateCertificateHTML } from "../utils/certificateUtils";

// const SuccessPage = () => {
//   const [userData, setUserData] = useState(null);
//   const [certificateData, setCertificateData] = useState(null);
//   const [checked, setChecked] = useState(false);

//   useEffect(() => {
//     const retrieveData = () => {
//       try {
//         const storedData = sessionStorage.getItem("certificateData");
//         if (storedData !== null) {
//           setUserData(JSON.parse(storedData));
//         }
//       } catch (error) {
//         console.error("Error retrieving data:", error);
//       }
//     };
//     retrieveData();
//   }, []);

//   console.log(userData);

//   useEffect(() => {
//     const config = {
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//         "x-api-key": 987654,
//       },
//     };

//     const checkTransaction = async () => {
//       try {
//         if (userData) {
//           const response = await axios.post(
//             "https://mosquepay.org/insurance_api/v1/api/checker",
//             qs.stringify({
//               trans_reference: userData.trans_reference,
//             }),
//             config
//           );
//           if (response.data.status_code === 0) {
//             setChecked(true);
//           }
//         }
//       } catch (error) {
//         console.log(error);
//       }
//     };

//     checkTransaction();
//     const intervalId = setInterval(checkTransaction, 30000);

//     return () => clearInterval(intervalId);
//   }, [userData]);

//   useEffect(() => {
//     const config = {
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//         "x-api-key": 987654,
//       },
//     };

//     const getCertificate = async () => {
//       try {
//         // if (userData) {
//         const response = await axios.post(
//           "https://mosquepay.org/insurance_api/v1/api/buy_insurance",
//           qs.stringify(userData),
//           // qs.stringify({
//           //   trans_reference: '2024101717383329759960616',
//           //   insured_name: 'Jon Dorian',
//           //   contact_address:
//           //     'Blk 9, Flat 2 Omole Phase 1 Housing Estate, Ikeja, Lagos.',
//           //   engine_capacity: '450hl',
//           //   engine_no: '8205823958',
//           //   chasis_no: '243424324324',
//           //   year_of_make: '2024',
//           //   registration_number: 'ISL145JI',
//           //   email: 'sanusiu111@gmail.com',
//           //   phonenumber: '09020033873',
//           //   type: 'Private',
//           //   category: 'Car',
//           //   make: 'Honda',
//           //   model: 'Ridgeline',
//           //   color: 'Navy blue',
//           // }),
//           config
//         );
//         console.log(response.data.result[0]);
//         if (response.data.status_code === "0" && response.data.link) {
//           setCertificateData(response?.data.result[0]);
//           // }
//         }
//       } catch (error) {
//         console.error("Error posting data:", error);
//       }
//     };

//     getCertificate();
//   }, [userData]);

//   const handlePrintCertificate = () => {
//     if (!certificateData) {
//       console.error("No certificate data available to print");
//       return;
//     }

//     const effectiveDate = new Date().toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "long",
//       year: "numeric",
//     });
//     const expiryDate = new Date();
//     expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//     const formattedExpiryDate = expiryDate.toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "long",
//       year: "numeric",
//     });

//     // Generate HTML content for the certificate
//     const htmlContent = generateCertificateHTML(
//       certificateData,
//       effectiveDate,
//       formattedExpiryDate
//     );

//     // Open a new window for printing
//     const printWindow = window.open("", "_blank");
//     printWindow.document.open();
//     printWindow.document.write(htmlContent);
//     printWindow.document.close();

//     // Trigger the print action
//     printWindow.onload = () => {
//       printWindow.print();
//     };
//   };

//   return (
//     <>
//       <div className="flex flex-col items-center justify-center space-y-6">
//         <div class="relative flex justify-center items-center w-56 h-56">
//           <div class="relative z-10 p-5 rounded-full bg-[#1FBE79] shadow-ripples">
//             <svg
//               width="50"
//               height="50"
//               viewBox="0 0 50 50"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <g clip-path="url(#clip0_4008_49)">
//                 <circle cx="25" cy="25" r="25" fill="#20BE79" />
//                 <path
//                   d="M24.602 26.7589L26.014 28.1709L34.4795 19.7053L35.8938 21.1195L26.014 30.9993L19.65 24.6353L21.0642 23.2211L23.189 25.3459L24.602 26.7589ZM24.6037 23.9312L29.5563 18.9785L30.9666 20.3888L26.014 25.3414L24.6037 23.9312ZM21.777 29.5863L20.364 30.9993L14 24.6353L15.4142 23.2211L16.8272 24.6342L16.826 24.6353L21.777 29.5863Z"
//                   fill="white"
//                 />
//               </g>
//               <defs>
//                 <clipPath id="clip0_4008_49">
//                   <rect width="50" height="50" fill="white" />
//                 </clipPath>
//               </defs>
//             </svg>
//           </div>
//         </div>

//         <p className="text-2xl font-bold text-green-400">Payment Successful</p>
//       </div>
//       <div className="flex items-center justify-center mt-10">
//         <button
//           type="submit"
//           onClick={handlePrintCertificate}
//           // className={`flex items-center justify-center px-3 py-3 text-md text-white rounded bg-dark ${
//           //   !checked ? 'button-disabled' : ''
//           // }`}
//           className="flex items-center justify-center px-3 py-3 text-white rounded text-md bg-dark"
//           // disabled={!checked}
//         >
//           Download Certificate
//         </button>
//         {/* <button onClick={handleDownloadPDF}>Download as PDF</button> */}
//       </div>
//     </>
//   );
// };

// export default SuccessPage;

import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import qs from "qs";
import { useEffect, useState } from "react";
import { generateCertificateHTML } from "../utils/certificateUtils";

const SuccessPage = () => {
  const [userData, setUserData] = useState(null);
  const [certificateData, setCertificateData] = useState(null);
  const [checked, setChecked] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const retrieveData = () => {
      try {
        const storedData = sessionStorage.getItem("certificateData");
        if (storedData !== null) {
          setUserData(JSON.parse(storedData));
        }
      } catch (error) {
        console.error("Error retrieving data:", error);
      }
    };
    retrieveData();
  }, []);

  useEffect(() => {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-api-key": 987654,
      },
    };

    const checkTransaction = async () => {
      try {
        if (userData) {
          const response = await axios.post(
            "https://mosquepay.org/insurance_api/v1/api/checker",
            qs.stringify({
              trans_reference: userData.trans_reference,
            }),
            config
          );
          if (response.data.status_code === 0) {
            setChecked(true);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    checkTransaction();
    const intervalId = setInterval(checkTransaction, 30000);

    return () => clearInterval(intervalId);
  }, [userData]);

  useEffect(() => {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-api-key": 987654,
      },
    };

    const getCertificate = async () => {
      try {
        const response = await axios.post(
          "https://mosquepay.org/insurance_api/v1/api/buy_insurance",
          qs.stringify(userData),
          config
        );
        if (response?.data?.status_code === "0" && response?.data?.link) {
          setCertificateData(response?.data?.result[0]);
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    getCertificate();
  }, [userData]);

  const handleDownloadCertificate = async () => {
    if (!certificateData) {
      console.error("No certificate data available to download");
      return;
    }

    setIsDownloading(true);

    try {
      const effectiveDate = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
      const expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      const formattedExpiryDate = expiryDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      // Generate HTML content for the certificate
      const htmlContent = generateCertificateHTML(
        certificateData,
        effectiveDate,
        formattedExpiryDate
      );

      // Parse HTML and extract body content
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Create temporary container
      const tempContainer = document.createElement("div");
      tempContainer.style.position = "absolute";
      tempContainer.style.left = "-9999px";
      tempContainer.style.top = "0";
      tempContainer.style.width = "794px"; // A4 width at 96 DPI
      tempContainer.style.background = "white";
      tempContainer.style.padding = "40px";

      // Copy the body content
      tempContainer.innerHTML = doc.body.innerHTML;
      document.body.appendChild(tempContainer);

      // Wait a bit for images to render
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Convert to canvas
      const canvas = await html2canvas(tempContainer, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 794,
      });

      // Remove temporary container
      document.body.removeChild(tempContainer);

      // Calculate PDF dimensions
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Create PDF
      const pdf = new jsPDF({
        orientation: imgHeight > imgWidth ? "portrait" : "portrait",
        unit: "mm",
        format: "a4",
      });

      // Add image to PDF
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

      // Download PDF
      pdf.save(
        `Hilal_Certificate_${
          certificateData?.hilal_certificate_no || Date.now()
        }.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center space-y-6">
        <div className="relative flex items-center justify-center w-56 h-56">
          <div className="relative z-10 p-5 rounded-full bg-[#1FBE79] shadow-ripples">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_4008_49)">
                <circle cx="25" cy="25" r="25" fill="#20BE79" />
                <path
                  d="M24.602 26.7589L26.014 28.1709L34.4795 19.7053L35.8938 21.1195L26.014 30.9993L19.65 24.6353L21.0642 23.2211L23.189 25.3459L24.602 26.7589ZM24.6037 23.9312L29.5563 18.9785L30.9666 20.3888L26.014 25.3414L24.6037 23.9312ZM21.777 29.5863L20.364 30.9993L14 24.6353L15.4142 23.2211L16.8272 24.6342L16.826 24.6353L21.777 29.5863Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_4008_49">
                  <rect width="50" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>

        <p className="text-2xl font-bold text-green-400">Payment Successful</p>
      </div>
      <div className="flex items-center justify-center mt-10">
        <button
          type="button"
          onClick={handleDownloadCertificate}
          disabled={isDownloading}
          className="flex items-center justify-center px-3 py-3 text-white rounded text-md bg-dark disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isDownloading ? "Generating PDF..." : "Download Certificate"}
        </button>
      </div>
    </>
  );
};

export default SuccessPage;
